import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const WarningIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M11 19h2v2h-2v-2ZM13 7h-2v10h2V7Z M12.124 0 0 24h24.249L12.124 0Zm0 2.218L1.626 23h20.997L12.124 2.218Z"
    />
  </IconWrapper>
)

export default WarningIconMedium
